module.exports = __webpack_public_path__ + "me.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/me.svg
// module id = 936
// module chunks = 0